import React from "react";
import { useParams } from "react-router-dom";
import TransactionTypeSalesOrder from "./transaction-type-salesOrder";
import TransactionTypeDefault from "./transaction-type-default";
import TransactionTypePurchaseOrder from "./transaction-type-purchaseOrder";
import TransactionTypeBill from "./transaction-type-bill";
import TransactionTypeCreditMemo from "./transaction-type-creditMemo";
import TransactionTypeDeposit from "./transaction-type-deposit";
import TransactionTypeInvoice from "./transaction-type-invoice";
import TransactionTypeJournal from "./transaction-type-journal";
import TransactionTypePayment from "./transaction-type-payment";
import TransactionTypeBillCredit from "./transaction-type-billCredit";
import TransactionTypeBillPayment from "./transaction-type-billPayment";
import TransactionTypeCheck from "./transaction-type-check";
import TransactionTypeCustomerRefund from "./transaction-type-customerRefund";
import TransactionTypeCurrencyRevaluation from "./transaction-type-currencyRevaluation";
import TransactionTypeExpenseReport from "./transaction-type-expenseReport";
import TransactionTypeRevenueArrangement from "./transaction-type-revenueArrangement";
import TransactionTypeTransfer from "./transaction-type-transfer";
import TransactionTypeVRA from "./transaction-type-VRA";
import TransactionTypeCreditCard from "./transaction-type-creditCard";
import TransactionTypeItemFulfilment from "./transaction-type-itemFulfilment";
import TransactionTypeCashSale from "./transaction-type-cashSale";
import TransactionTypeItemReceipt from "./transaction-type-itemReceipt";
import TransactionTypeCardRefund from "./transaction-type-cardRefund";
import TransactionTypeCustom from "./transaction-type-custom";
import TransactionTypeQuote from "./transaction-type-quote";
import TransactionTypeCreditCardRefund from "./transaction-type-ccardrefund";

export default function TransactionDocumentDetails() {
  const params = useParams();

  return (
    <>
      {params.slug === "sales-order" ? (
        <TransactionTypeSalesOrder />
      ) : params.slug === "purchase-order" ? (
        <TransactionTypePurchaseOrder />
      ) : params.slug === "invoice" ? (
        <TransactionTypeInvoice />
      ) : params.slug === "journal" ? (
        <TransactionTypeJournal />
      ) : params.slug === "vendor-bill-list" ? (
        <TransactionTypeBill />
      ) : params.slug === "credit-memo" ? (
        <TransactionTypeCreditMemo />
      ) : params.slug === "payment" ? (
        <TransactionTypePayment />
      ) : params.slug === "deposit" ? (
        <TransactionTypeDeposit />
      ) : params.slug === "bill-credit-list" ? (
        <TransactionTypeBillCredit />
      ) : params.slug === "check" ? (
        <TransactionTypeCheck />
      ) : params.slug === "bill-payment-list" ? (
        <TransactionTypeBillPayment />
      ) : params.slug === "customer-refund" ? (
        <TransactionTypeCustomerRefund />
      ) : params.slug === "currency-revaluation" ? (
        <TransactionTypeCurrencyRevaluation />
      ) : params.slug === "expense-report" ? (
        <TransactionTypeExpenseReport />
      ) : params.slug === "revenue-arrangement" ? (
        <TransactionTypeRevenueArrangement />
      ) : params.slug === "transfer" ? (
        <TransactionTypeTransfer />
      ) :params.slug === "vendor-return-authorization" ? (
        <TransactionTypeVRA />
      ) : params.slug === "credit-card" ? (
        <TransactionTypeCreditCard />
      ) : params.slug === "item-fulfillment" ? (
        <TransactionTypeItemFulfilment />
      ) :  params.slug === "cash-sale" ? (
        <TransactionTypeCashSale />
      ) :params.slug === "item-receipt" ? (
        <TransactionTypeItemReceipt />
      ) :params.slug === "customer-refund" ? (
        <TransactionTypeCustomerRefund />
      ) :params.slug === "custom" ? (
        <TransactionTypeCustom />
      ) :params.slug === "estimate" ? (
        <TransactionTypeQuote />
      ) :params.slug === "credit-card-refund" ? (
        <TransactionTypeCreditCardRefund />
      ) :params.slug === "ap-check" ? (
        <TransactionTypeCustom />
      ) :(
        <TransactionTypeDefault />
      )}
    </>
  );
}




